import type { CandidateReportEntry } from '@recruitai/shared';

interface CandidateReportTableProps {
  candidates: CandidateReportEntry[];
}

const STATUS_LABELS: Record<string, string> = {
  pending: 'Pendente',
  analyzing: 'Analisando',
  approved: 'Aprovado',
  rejected: 'Rejeitado',
  interviewed: 'Entrevistado',
  hired: 'Contratado',
};

const STATUS_COLORS: Record<string, string> = {
  pending: 'bg-gray-100 text-gray-700',
  analyzing: 'bg-blue-100 text-blue-700',
  approved: 'bg-green-100 text-green-700',
  rejected: 'bg-red-100 text-red-700',
  interviewed: 'bg-purple-100 text-purple-700',
  hired: 'bg-yellow-100 text-yellow-700',
};

export function CandidateReportTable({ candidates }: CandidateReportTableProps) {
  const sorted = [...candidates].sort((a, b) => (b.finalScore ?? b.fitScore) - (a.finalScore ?? a.fitScore));

  return (
    <div className="bg-white rounded-lg border overflow-hidden">
      <div className="px-4 py-3 border-b">
        <h3 className="text-sm font-medium text-gray-700">Candidatos ({sorted.length})</h3>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-gray-50">
            <tr>
              <th className="text-left px-4 py-2 font-medium text-gray-600">Nome</th>
              <th className="text-left px-4 py-2 font-medium text-gray-600">Status</th>
              <th className="text-right px-4 py-2 font-medium text-gray-600">Fit Score</th>
              <th className="text-right px-4 py-2 font-medium text-gray-600">Entrevista</th>
              <th className="text-right px-4 py-2 font-medium text-gray-600">Final</th>
            </tr>
          </thead>
          <tbody>
            {sorted.map((c) => (
              <tr key={c.candidateId} className="border-t hover:bg-gray-50">
                <td className="px-4 py-2 text-gray-900">{c.name}</td>
                <td className="px-4 py-2">
                  <span className={`inline-block px-2 py-0.5 rounded text-xs font-medium ${STATUS_COLORS[c.status] || 'bg-gray-100 text-gray-700'}`}>
                    {STATUS_LABELS[c.status] || c.status}
                  </span>
                </td>
                <td className="px-4 py-2 text-right text-gray-700">{c.fitScore}</td>
                <td className="px-4 py-2 text-right text-gray-700">{c.interviewScore ?? '—'}</td>
                <td className="px-4 py-2 text-right font-medium text-gray-900">{c.finalScore ?? '—'}</td>
              </tr>
            ))}
            {sorted.length === 0 && (
              <tr>
                <td colSpan={5} className="px-4 py-6 text-center text-gray-500">Nenhum candidato encontrado</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
